/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * 十八线_接口文档
 * 十八线——小众旅游
 * OpenAPI spec version: 版本号:0.0.1
 */
import type {
  AjaxResult,
  RewardTierDetailPathParameters,
  RewardTierListParams,
  RewardTierPublishGoodsPathParameters,
  RewardTierRemovePathParameters,
  RewardTierSyncGoodsParams,
  RewardTierUploadGoodsPathParameters,
  TableDataInfo,
  TravelRewardTier
} from '../../../types/api';

import { orvalMutator } from '../../../utils/orval-mutator';



  export const get = () => {
/**
 * @summary 修改打赏档位
 */
const rewardTierEdit = (
    travelRewardTier: TravelRewardTier,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/tier`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: travelRewardTier
    },
      );
    }
  /**
 * @summary 新增打赏档位
 */
const rewardTierAdd = (
    travelRewardTier: TravelRewardTier,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/tier`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: travelRewardTier
    },
      );
    }
  /**
 * @summary 提交道具上传任务（异步，需同步确认结果）
 */
const rewardTierUploadGoods = (
    { tierId }: RewardTierUploadGoodsPathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/tier/${tierId}/upload`, method: 'POST'
    },
      );
    }
  /**
 * @summary 提交道具发布任务（发布前核对微信侧价格）
 */
const rewardTierPublishGoods = (
    { tierId }: RewardTierPublishGoodsPathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/tier/${tierId}/publish`, method: 'POST'
    },
      );
    }
  /**
 * @summary 同步指定环境的道具状态（全量对账）
 */
const rewardTierSyncGoods = (
    params: RewardTierSyncGoodsParams,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/tier/sync`, method: 'POST',
        params
    },
      );
    }
  /**
 * @summary 手工触发待同步档位的状态同步
 */
const rewardTierSyncPending = (

 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/tier/sync/pending`, method: 'POST'
    },
      );
    }
  /**
 * @summary 查询打赏档位详情
 */
const rewardTierDetail = (
    { tierId }: RewardTierDetailPathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/tier/${tierId}`, method: 'GET'
    },
      );
    }
  /**
 * @summary 查询打赏档位列表
 */
const rewardTierList = (
    params: RewardTierListParams,
 ) => {
      return orvalMutator<TableDataInfo>(
      {url: `/travel18/reward/tier/list`, method: 'GET',
        params
    },
      );
    }
  /**
 * @summary 删除打赏档位
 */
const rewardTierRemove = (
    { tierIds }: RewardTierRemovePathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/tier/${tierIds}`, method: 'DELETE'
    },
      );
    }
  return {rewardTierEdit,rewardTierAdd,rewardTierUploadGoods,rewardTierPublishGoods,rewardTierSyncGoods,rewardTierSyncPending,rewardTierDetail,rewardTierList,rewardTierRemove}};
export type RewardTierEditResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardTierEdit']>>>
export type RewardTierAddResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardTierAdd']>>>
export type RewardTierUploadGoodsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardTierUploadGoods']>>>
export type RewardTierPublishGoodsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardTierPublishGoods']>>>
export type RewardTierSyncGoodsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardTierSyncGoods']>>>
export type RewardTierSyncPendingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardTierSyncPending']>>>
export type RewardTierDetailResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardTierDetail']>>>
export type RewardTierListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardTierList']>>>
export type RewardTierRemoveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardTierRemove']>>>
